import * as React from 'react'
import './list.css'
import { Box, IconButton, Switch, TextField, useTheme } from '@mui/material'
import { Link } from 'react-router-dom'
import TablePagination from '@mui/material/TablePagination'
import ContentCopyRoundedIcon from '@mui/icons-material/ContentCopyRounded';
import LockIcon from '@mui/icons-material/Lock';
import { useState } from 'react'
import utils from '../../scripts/utils'
import { useSnackbar } from "notistack";
import PaymentDetailModal from '../Modals/Payment-detail-modal'
import { useRef } from 'react'
import context from '../../scripts/context'
import { useEffect } from 'react'
import PropTypes from 'prop-types';
import { FirstPage, KeyboardArrowLeft, KeyboardArrowRight, LastPage, KeyboardArrowDown } from '@mui/icons-material'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import AirplaneTicketIcon from '@mui/icons-material/AirplaneTicket';
import ErrorIcon from '@mui/icons-material/Error';
import { ajax } from '../../scripts/helper'
import SwapVertIcon from '@mui/icons-material/SwapVert';
import ThumbUpAltIcon from '@mui/icons-material/ThumbUpAlt';
function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;
  const [pagetext, setPagetext] = useState(page + 1)

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
    setPagetext(1)
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
    setPagetext(page)
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
    setPagetext(page + 2)
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    setPagetext(Math.max(0, Math.ceil(count / rowsPerPage)))
  };

  const handleTextPageChange = (event) => {
    setPagetext(event.target.value)
  }

  const onEnter = (event) => {
    if (event.keyCode === 13) {
      let p = parseInt(pagetext) || 1
      if (p > Math.ceil(count / rowsPerPage)) p = Math.ceil(count / rowsPerPage)
      setPagetext(p)
      onPageChange(event, p - 1)
    }
  }

  useEffect(() => {
    setPagetext(page + 1)
  }, [page])

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === 'rtl' ? <LastPage /> : <FirstPage />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <TextField
        type='number'
        size="small"
        variant="standard"
        value={pagetext}
        onChange={handleTextPageChange}
        onKeyDown={onEnter}
        inputProps={{ style: { fontSize: "14px", textAlign: "center" } }}
        style={{ width: "30px", textAlign: "center", fontsize: "8px", padding: "6px" }} />
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === 'rtl' ? <FirstPage /> : <LastPage />}
      </IconButton>
    </Box>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

const List = ({ columns, rows, serviceId, type, totalCounts, page, rowsPerPage = 10, onPageChange, actions, sortObj }) => {

  // const [currentPage, setCurrentPage] = React.useState(0)
  // const columns = [
  //     { name: 'office Id'},
  //     { name: 'office name'}
  // ]
  console.log('INFO:LIST ', page, totalCounts)
  const [Page, setPage] = useState(page)
  const [RowsPerPage, setRowsPerPage] = useState(rowsPerPage)
  const { enqueueSnackbar } = useSnackbar()
  const paymentDetailModal = useRef()
  const [data, setData] = useState({})
  const [sortObject, setSortObject] = useState({
    sortField: sortObj?.sortField,
    direction: sortObj?.direction || 'DESC'
  })

  const handleChangePage = (event, newPage) => {
    setPage(newPage)
    onPageChange(newPage, RowsPerPage)
  };

  const handleRowsPerPageChange = (event) => {
    const rpp = parseInt(event.target.value, 10)
    console.log('LIST COMPONENT ', rpp)
    setRowsPerPage(rpp);
    setPage(0);
    onPageChange(0, rpp)
  };

  const status2class = (status) => {
    return {
      CREATED: 'info',
      PAID: 'success',
      SENT_TO_PGW: 'warn',
      USER_FAILED: 'err',
      SERVER_FAILED: 'err',
      BLOCKED: 'block'
    }[status]
  }
  const rowStatus = (row) => {
    let rowstatus = {
      PAID: 'success',
      BLOCKED: 'err'
    }[row.status]
    if (!rowstatus) {
      const now = new Date().getTime()
      const rowdate = new Date(row.validity).getTime()
      if (now > rowdate) rowstatus = 'warn'
    }
    return rowstatus
  }

  const copyToClipboard = (id) => {
    navigator.clipboard.writeText(`${utils.baseUrl}/${id}`)
    enqueueSnackbar("Copied!", { variant: 'success' })
  }

  const getOffice = context.getUserInfo()


  const openDetailModal = (row) => {
    setData(row)
    paymentDetailModal.current.openModal()
  }

  useEffect(() => {
    setPage(page)
  }, [page])

  useEffect(() => {
    setSortObject({
      sortField: sortObj?.sortField,
      direction: sortObj?.direction || 'DESC'
    })
  }, [sortObj])

  const sortAction = (field) => {
    if (!actions || !actions.onSortChange) return
    let newFiled = field
    let newDirection
    if (field === sortObject.sortField) {
      newDirection = (sortObject.direction === 'DESC' ? 'ASC' : 'DESC')
      setSortObject({ ...sortObject, direction: newDirection })

    } else {
      newDirection = 'DESC'
      setSortObject({ sortField: field, direction: 'DESC' })
    }



    actions.onSortChange(newFiled, newDirection)
  }

  const inquiry = async (id) => {
    if (!actions || !actions.inquiry) return
    actions.inquiry(id)

  }


  return (
    <>

      <table className='list'>
        <thead className='list__header'>
          <tr>
            {
              columns.map(col =>
                <th onClick={() => sortAction(col.field)}>{col.name} {(col.field && sortObject.sortField === col.field ? (sortObject.direction === 'DESC' ? <span style={{ verticalAlign: 'middle' }}><KeyboardArrowUpIcon fontSize='10px' /></span> : <span style={{ verticalAlign: 'middle' }}><KeyboardArrowDown fontSize='10px' /></span>) : '')}</th>
              )
            }

          </tr>
        </thead>
        <tbody className='list__body'>
          {
            type == 'offices' &&
            rows.map(row =>
              <tr key={row.id}>
                <th>{row.id}</th>
                <th>{row.code}</th>
                <th>{row.email}</th>
                <th>{row.phone}</th>
                <th>{row.mobile}</th>
                <th>{row.contactPerson}</th>
                <th style={{ textAlign: '-webkit-center' }}>
                  <span style={{ display: 'inline' }}>
                    <Switch color='primary' checked={row.paymentStatus === 'ACTIVE'} onChange={() => actions.onChangePaymentStatus(row)} size='small' />
                  </span>
                </th>
                <th style={{ textAlign: '-webkit-center' }}>
                  <span style={{ display: 'inline' }}>
                    <Switch color='primary' checked={row.status === 'ACTIVE'} onChange={() => actions.onChangeOfficeStatus(row)} size='small' />
                  </span>
                </th>
                <th>
                  <div className='icon-container'>
                    <Link to={'/agent/offices/detail?type=detail'} state={row}>
                      <img src='/images/detail.svg' title='Detail'></img>
                    </Link>
                    <Link to={`/agent/offices/detail?id=${row.id}`} state={row}>
                      <img src='/images/edit.svg' style={{ width: '16px' }} title='Edit'></img>
                    </Link>
                  </div>
                </th>
              </tr>
            )
          }
          {
            type == 'members' &&
            rows.map(row =>
              <tr key={row.id}>
                <th>{row.id}</th>
                <th>{row.username}</th>
                <th>{row.name}</th>
                <th>{row.email}</th>
                <th>{row.mobile}</th>
                <th>{row.office.code}</th>
                <th>
                  <div className='icon-container'>
                    <Link to={'/agent/users/single?type=detail'} state={row}>
                      <img src='/images/detail.svg' title='Detail'></img>
                    </Link>
                    <Link to={`/agent/users/single?type=edit`} state={row}>
                      <img src='/images/edit.svg' style={{ width: '16px' }} title='Edit'></img>
                    </Link>
                  </div>
                </th>
              </tr>
            )
          }

          {
            type == 'roles' &&
            rows?.map(row =>
              <tr key={row.id}>
                <th>{row.id}</th>
                <th>{row.name}</th>
                <th>{row.description}</th>
                <th>
                  <div className='icon-container'>
                    <Link to={'/agent/roles/single?type=detail'} state={row}>
                      <img src='/images/detail.svg' title='Detail'></img>
                    </Link>
                    <Link to={`/agent/roles/single?type=edit`} state={row}>
                      <img src='/images/edit.svg' style={{ width: '16px' }} title='Edit'></img>
                    </Link>
                  </div>
                </th>
              </tr>
            )
          }
          {
            type === 'paymentsHistory' &&
            rows.map(row =>
              <tr key={row.name}>
                <th>{row.id}</th>
                <th>{row.user?.name}</th>
                <th>{utils.dateFormat(row.creationDate)}</th>
                <th>{row.summary}</th>
                <th>
                  <div className='icon-container'>
                    <img src='/images/detail.svg' onClick={() => actions.onShowHistoryDetail(row)} />
                  </div>
                </th>
              </tr>
            )
          }

          {
            type == 'payments' &&
            rows.map(row =>
              <tr key={row.id} className={`status status-${rowStatus(row)}`}>
                <th>{row.id}</th>
                <th>
                  {
                    row.paymentType === 'LINK' ?
                      <>
                        <Link target='_blank' to={"/" + row.id} >{row.paymentType}</Link>
                        <span className='action' onClick={() => copyToClipboard(row.id)}><ContentCopyRoundedIcon sx={{ fontSize: "14px" }} /></span>
                      </>
                      : row.paymentType === 'POS' ?
                        <span>POS</span> :
                        <span>REFUND_IBAN</span>
                  }
                </th>
                <th>{row.product.name} </th>
                <th>{row.reference}</th>
                <th>
                  {
                    row.paymentType === 'LINK' ?
                      <>
                        <span>{row.primaryContact?.split(',')[0]}</span>
                        <span>{row.email}</span>
                        <span>{row.mobile}</span>
                      </> :
                      row.paymentType === 'POS' ?
                        <>
                          <span>{row.createdBy?.office?.name}</span>
                          <span>{row.primaryContact?.split(',')[0]}</span>
                          <span>{row.account.name}</span>

                        </> :
                        <>
                          <span>{row.createdBy?.office?.name}</span>
                          <span>{row.primaryContact?.split(',')[0]}</span>
                          <span>{row.account.name}</span>

                        </>


                  }
                </th>
                <th>
                  <span>C:{utils.dateFormat(row.creationDate)}</span>
                  <span>E:{utils.dateFormat(row.validity)}</span>
                </th>
                <th>
                  {row.amount.toLocaleString() + ' ' + row.currency.code}
                  {' '}
                  {row.autoAmount && <span className='action' style={{ cursor: 'auto' }}> <LockIcon sx={{ fontSize: "16px" }} titleAccess='Auto Price Enabled' /></span>}
                  {(row.autoBooking ? <AirplaneTicketIcon sx={{ fontSize: "18px", marginBottom: "-4px", color: "#007bff" }} titleAccess='Auto Booking Enabled' /> : '')}
                </th>
                <th >
                  {(row.status === 'PAID' && row.autoBooking && row.bookingStatus === 'WARNING' ? <WarningAmberIcon sx={{ fontSize: "18px", color: "#991B1B", marginBottom: "-5px" }} titleAccess='Booking has some warning. check the booking manually.' /> : row.status === 'PAID' && row.autoBooking && row.bookingStatus === 'FAILED' ? <ErrorIcon sx={{ fontSize: "18px", color: "#991B1B", marginBottom: "-5px" }} titleAccess='Booking has error. check the issuance manually.' /> : '')}
                  <span tip={row.status === 'PAID' ? utils.dateFormat(row.transactionDateTime) : utils.dateFormat(row.modificationDate)}
                    className={`tooltip status status-${status2class(row.status)}`}
                    style={{ display: 'inline' }}>
                    {row.status}
                  </span>
                </th>
                <th>
                  <div className='payment-icon-container'>
                    <Switch color='primary' checked={row.status !== 'BLOCKED'} onChange={() => actions.onBlockPayment(row)} size="small" />
                    {
                      row.paymentType === 'LINK' &&
                      <Link to={"/agent/payments/send"} state={row} className='tooltip' tip={((row.lastSmsDelivery ? ("SMS: " + new Date(row.lastSmsDelivery).toLocaleString()) : '') +
                        ((row.lastEmailDelivery && row.lastSmsDelivery) ? "\n" : '') +
                        (row.lastEmailDelivery ? ("Email: " + new Date(row.lastEmailDelivery).toLocaleString()) : '')) || "not deliverd"}>
                        <img src='/images/clockwise.svg' title='Resend'></img>
                      </Link>
                    }

                    {
                      row.paymentType === 'POS' && (row.status === 'USER_FAILED' || row.status === 'CREATED') &&
                      <Link to={"/agent/payments/send-to-pos"} state={row}>
                        <img src='/images/clockwise.svg' title='Resend'></img>
                      </Link>
                    }
                    {
                      row.paymentType === 'POS' && (row.status === 'SENT_TO_PGW' || row.status === 'USER_FAILED') && new Date(row.validity) < new Date() &&
                      <SwapVertIcon titleAccess='inquiry' onClick={() => inquiry(row.id)} style={{ 'cursor': 'pointer' }} />
                    }

                    {/* <Link to={`/agent/payments/single?id=${row.id}`}> */}
                    {/* { */}

                    <img src='/images/detail.svg' title='Detail' className='detail-btn' onClick={() => openDetailModal(row)}></img>
                    {/* } */}
                    {/* </Link> */}
                    {
                      row.paymentType === 'LINK' &&
                      <Link to={(row.autoAmount ? `/agent/payments/single-by-pnr?id=${row.id}` : `/agent/payments/single?id=${row.id}`)}>
                        <img src='/images/edit.svg' className='edit-icon' title='Edit'></img>
                      </Link>
                    }
                    {
                      row.paymentType === 'POS' &&
                      <Link to={`/agent/payments/pos-payment?id=${row.id}`}>
                        <img src='/images/edit.svg' className='edit-icon' title='Edit'></img>
                      </Link>
                    }
                    {
                      row.paymentType === 'REFUND_IBAN' &&
                      <Link to={`/agent/payments/refund?id=${row.id}`}>
                        <img src='/images/edit.svg' className='edit-icon' title='Edit'></img>
                      </Link>
                    }
                    {
                      row.paymentType === 'REFUND_IBAN' && window.localStorage.getItem('privileges').includes("CONFIRM_TRANSACTION") &&
                      <Link to={`/agent/payments/refund/confirmation?id=${row.id}`} state={row}>
                        <ThumbUpAltIcon style={{ 'cursor': 'pointer', 'fontSize': '22px' }} htmlColor='black' />
                      </Link>
                    }
                    <Link to={`/agent/payments/history?id=${row.id}`}>
                      <img src='/images/history.svg' title='History'></img>
                    </Link>
                    {/* <Link to={"/agent/payments/single"}>
                                        <img src='/images/bin.svg' title='Delete'></img>
                                    </Link> */}
                    <PaymentDetailModal ref={paymentDetailModal} data={data} />
                  </div>
                </th>
              </tr>
            )}
          <tr>
            <TablePagination
              page={Page}
              count={totalCounts}
              onPageChange={handleChangePage}
              rowsPerPage={RowsPerPage}
              rowsPerPageOptions={[10, 20, 50, 100]}
              onRowsPerPageChange={handleRowsPerPageChange}
              ActionsComponent={TablePaginationActions}
            /></tr>

        </tbody>
      </table>
    </>
  )
}

export default List
